<script setup>
defineProps({
  width: {
    type: Number,
    default: 24,
  },
  height: {
    type: Number,
    default: 24,
  },
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 15.6523C14.0171 15.6523 15.6523 14.0171 15.6523 12C15.6523 9.98287 14.0171 8.34766 12 8.34766C9.98287 8.34766 8.34766 9.98287 8.34766 12C8.34766 14.0171 9.98287 15.6523 12 15.6523Z"
      fill="#8C8C8C"
    />
    <path
      d="M7.17268 10.9435C7.65788 8.72479 9.63784 7.05859 12 7.05859H21.8339C21.3121 6.02275 20.6222 5.06579 19.7782 4.2218C17.7005 2.14421 14.9382 1 12 1C9.0618 1 6.29947 2.14421 4.2218 4.2218C4.02199 4.4216 3.83104 4.62785 3.64872 4.83986L7.17268 10.9435Z"
      fill="#8C8C8C"
    />
    <path
      d="M13.4988 16.7088C13.0258 16.8597 12.5223 16.9414 12 16.9414C10.1645 16.9414 8.55958 15.9353 7.70751 14.4457C7.70141 14.4363 7.69535 14.4269 7.68968 14.4171L2.80516 5.95688C1.63082 7.73578 1 9.81934 1 12C1 14.9382 2.14421 17.7005 4.2218 19.7782C5.81349 21.3699 7.80724 22.4129 9.97385 22.8141L13.4988 16.7088Z"
      fill="#8C8C8C"
    />
    <path
      d="M15.3249 8.34766C16.3175 9.25206 16.9414 10.5545 16.9414 12C16.9414 12.9091 16.6943 13.7615 16.2642 14.4941C16.2598 14.5025 16.2561 14.5111 16.2513 14.5193L11.3657 22.9814C11.5762 22.9933 11.7876 23 12 23C14.9382 23 17.7005 21.8558 19.7782 19.7782C21.8558 17.7005 23 14.9382 23 12C23 10.7365 22.7878 9.50566 22.3814 8.34766H15.3249Z"
      fill="#8C8C8C"
    />
  </svg>
</template>
